import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _Array$from from "@babel/runtime-corejs3/core-js-stable/array/from";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as React from 'react';
import classNames from 'classnames';
import isBoolean from 'lodash/isBoolean';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import Icon from '../icon';
import Dropdown from '../dropdown';
import devWarning from '../_utils/devwarning';
import { tuple } from '../_utils/type';
export var PageTypes = tuple('basic', 'bill', 'simple', 'less', 'nicety');
export var TotalTypes = tuple('page', 'row', 'all');

var Pagination = function Pagination(props) {
  var _context4;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps,
      locale = _React$useContext.locale;

  var paginationLangMsg = locale.getCompLangMsg({
    componentName: 'Pagination'
  }); // 属性需要合并一遍用户定义的默认属性

  var _getCompProps = getCompProps('Pagination', userDefaultProps, props),
      style = _getCompProps.style,
      total = _getCompProps.total,
      current = _getCompProps.current,
      pageSize = _getCompProps.pageSize,
      disabled = _getCompProps.disabled,
      onChange = _getCompProps.onChange,
      pageType = _getCompProps.pageType,
      bordered = _getCompProps.bordered,
      showTitle = _getCompProps.showTitle,
      className = _getCompProps.className,
      dropdownProps = _getCompProps.dropdownProps,
      defaultCurrent = _getCompProps.defaultCurrent,
      showQuickJumper = _getCompProps.showQuickJumper,
      defaultPageSize = _getCompProps.defaultPageSize,
      pageSizeOptions = _getCompProps.pageSizeOptions,
      showSizeChanger = _getCompProps.showSizeChanger,
      onShowSizeChange = _getCompProps.onShowSizeChange,
      hideOnSinglePage = _getCompProps.hideOnSinglePage,
      customPrefixcls = _getCompProps.prefixCls;

  devWarning(PageTypes.indexOf(pageType) === -1, 'Pagination', "cannot found pageType '".concat(pageType, "'")); // className前缀

  var prefixCls = getPrefixCls(pkgPrefixCls, 'pagination', customPrefixcls); // 每页显示的记录条数

  var _React$useState = React.useState(pageSize || defaultPageSize),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      size = _React$useState2[0],
      setSize = _React$useState2[1];

  React.useEffect(function () {
    pageSize !== undefined && setSize(pageSize);
  }, [pageSize]); // 总页数

  var totalPage = Math.max(Math.ceil(total / size), 1); // 当前页码

  var initPage = Math.min(totalPage, current || defaultCurrent);

  var _React$useState3 = React.useState(Math.max(initPage, 1)),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      page = _React$useState4[0],
      setPage = _React$useState4[1];

  React.useEffect(function () {
    current !== undefined && setPage(current);
  }, [current]); // 输入的页码

  var _React$useState5 = React.useState(undefined),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      inputPage = _React$useState6[0],
      setInputPage = _React$useState6[1]; // 是否显示pageSize切换器


  var showSizeSelector = isBoolean(showSizeChanger) ? showSizeChanger : total > 50;
  var defaultShowQuickJumper = pageType !== 'bill';
  var showJumper = showQuickJumper === undefined ? defaultShowQuickJumper : showQuickJumper; // pageSize切换器是否展开

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      isOpen = _React$useState8[0],
      setIsOpen = _React$useState8[1]; // 切换pageSize


  var handleChangeSize = function handleChangeSize(key) {
    var currentSize = Number(key);

    if (currentSize !== size) {
      if (pageSize === undefined) setSize(currentSize);
      var currentPage = Math.min(Math.ceil(total / Number(currentSize)), page);
      changePage(currentPage, currentSize);
      onShowSizeChange && onShowSizeChange(currentPage, currentSize);
    }

    setIsOpen(false);
  }; // 输入页码


  var handleChangeCurrentPage = function handleChangeCurrentPage(e) {
    return setInputPage(e.target.value);
  }; // 回车确定页码


  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === 'Enter') handleConfirmCurrentPage();
  }; // 页码输入框回车或者失去焦点确定翻到输入的页码


  var handleConfirmCurrentPage = function handleConfirmCurrentPage() {
    if (inputPage !== undefined) {
      // 正整数正则表达式
      var inputReg = new RegExp("^-?\\d+$");

      if (inputReg.test(inputPage)) {
        if (Number(inputPage) < 1) changePage(1);else if (Number(inputPage) > totalPage) changePage(totalPage);else changePage(Number(inputPage));
      }

      setInputPage(undefined);
    }
  }; // 翻页


  var changePage = function changePage(page, pageSize) {
    current === undefined && setPage(page);
    onChange && onChange(page, pageSize || size);
  }; // 翻到上一页


  var handlePrev = function handlePrev() {
    return changePage(page - 1);
  }; // 翻到下一页


  var handleNext = function handleNext() {
    return changePage(page + 1);
  }; // 翻到第一页


  var handleFirst = function handleFirst() {
    return changePage(1);
  }; // 翻到最后一页


  var handleLast = function handleLast() {
    return changePage(totalPage);
  }; // 向前跳转


  var jumpPrev = function jumpPrev() {
    return changePage(page - 5 || 1);
  }; // 向后跳转


  var jumpNext = function jumpNext() {
    return changePage(page + 5 < totalPage ? page + 5 : totalPage);
  };

  var itemAttr = function itemAttr(prefix, title, active) {
    var _context, _classNames;

    return {
      className: classNames((_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(prefixCls, "-")).call(_context, prefix), true), _defineProperty(_classNames, "bordered", bordered), _defineProperty(_classNames, "active", active), _classNames)),
      title: showTitle ? title : undefined
    };
  }; // 生成元素是连续数字的数组


  function genArray(start, end) {
    var _context2, _context3;

    return _sliceInstanceProperty(_context2 = _Array$from(_keysInstanceProperty(_context3 = Array(end + 1)).call(_context3))).call(_context2, start);
  }

  function dropdownVisibleChange(visible) {
    setIsOpen(visible);

    if (dropdownProps && typeof dropdownProps.onVisibleChange === 'function') {
      dropdownProps.onVisibleChange(visible);
    }
  }

  var sizeOptions = /*#__PURE__*/React.createElement(Dropdown.Menu, null, _mapInstanceProperty(pageSizeOptions).call(pageSizeOptions, function (size) {
    return /*#__PURE__*/React.createElement(Dropdown.Item, {
      key: size
    }, pageType === 'nicety' ? size : locale.getLangMsg('Pagination', 'perPage', {
      size: size
    }));
  }));
  var mapShowTotal = {
    basic: 'page',
    nicety: 'row'
  };
  var mapTotalText = {
    page: locale.getLangMsg('Pagination', 'page', {
      page: totalPage
    }),
    row: locale.getLangMsg('Pagination', 'row', {
      row: total
    }),
    all: locale.getLangMsg('Pagination', 'total', {
      page: totalPage,
      row: total
    })
  };
  var showTotal = props.showTotal ? props.showTotal === true ? 'page' : props.showTotal : mapShowTotal[pageType];
  var Total = showTotal && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-total")
  }, mapTotalText[showTotal]);
  var normalPagination = /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, className),
    style: style
  }, Total, showJumper && /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-current")
  }, locale.getLangMsg('Pagination', 'order', {
    order: /*#__PURE__*/React.createElement("input", {
      type: "text",
      disabled: disabled,
      onKeyUp: handleKeyUp,
      onBlur: handleConfirmCurrentPage,
      onChange: handleChangeCurrentPage,
      className: "".concat(prefixCls, "-current-input"),
      value: inputPage === undefined ? page : inputPage
    })
  })), /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-action")
  }, /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', paginationLangMsg.first)), /*#__PURE__*/React.createElement("button", {
    onClick: handleFirst,
    disabled: page === 1 || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "first"
  }))), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', paginationLangMsg.prevPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handlePrev,
    disabled: page === 1 || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  }))), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', paginationLangMsg.nextPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handleNext,
    disabled: page === totalPage || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  }))), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', paginationLangMsg.last)), /*#__PURE__*/React.createElement("button", {
    onClick: handleLast,
    disabled: page === totalPage || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "last"
  })))), showSizeSelector && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-selector")
  }, /*#__PURE__*/React.createElement(Dropdown, _extends({
    selectable: true,
    selectedKey: size,
    menu: sizeOptions,
    trigger: "click",
    placement: "bottomRight",
    disabled: disabled,
    prefix: "".concat(prefixCls, "-dropdown"),
    popperStyle: {
      minWidth: 64
    },
    onItemClick: handleChangeSize,
    getPopupContainer: function getPopupContainer(triggerNode) {
      return triggerNode === null || triggerNode === void 0 ? void 0 : triggerNode.parentElement;
    }
  }, dropdownProps, {
    onVisibleChange: dropdownVisibleChange
  }), /*#__PURE__*/React.createElement("button", {
    className: "".concat(prefixCls, "-selector-size")
  }, /*#__PURE__*/React.createElement("span", null, locale.getLangMsg('Pagination', 'perPage', {
    size: size
  })), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-down",
    className: classNames("".concat(prefixCls, "-dropdown-icon"), _defineProperty({}, "".concat(prefixCls, "-dropdown-icon-open"), isOpen))
  })))));
  var simplePagination = /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, 'simple', className),
    style: style
  }, Total, /*#__PURE__*/React.createElement("ul", {
    className: classNames("".concat(prefixCls, "-action"), {
      bordered: bordered,
      disabled: disabled
    })
  }, /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', paginationLangMsg.prevPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handlePrev,
    disabled: page === 1 || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  }))), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', _concatInstanceProperty(_context4 = "".concat(page, "/")).call(_context4, totalPage))), /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-current")
  }, showJumper ? /*#__PURE__*/React.createElement("input", {
    type: "text",
    disabled: disabled,
    onKeyUp: handleKeyUp,
    onBlur: handleConfirmCurrentPage,
    onChange: handleChangeCurrentPage,
    className: "".concat(prefixCls, "-current-input"),
    value: inputPage === undefined ? page : inputPage
  }) : page), "/ ", /*#__PURE__*/React.createElement("span", {
    className: "".concat(prefixCls, "-total")
  }, totalPage)), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('action-item', paginationLangMsg.nextPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handleNext,
    disabled: page === totalPage || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })))));
  var lessPages = genArray(1, totalPage);
  var lessPagination = /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, 'less', {
      bordered: bordered,
      disabled: disabled
    }, className),
    style: style
  }, Total, /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-pages")
  }, /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('pages-item', paginationLangMsg.prevPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handlePrev,
    disabled: page === 1 || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  }))), _mapInstanceProperty(lessPages).call(lessPages, function (item, index) {
    return /*#__PURE__*/React.createElement("li", _extends({
      key: index
    }, itemAttr('pages-item', String(item), item === page)), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return changePage(item);
      },
      disabled: disabled
    }, item));
  }), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('pages-item', paginationLangMsg.nextPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handleNext,
    disabled: page === totalPage || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })))));
  var nicetyPages = lessPages;

  if (totalPage >= 8) {
    nicetyPages.length = 0;

    if (page < 5) {
      nicetyPages.push.apply(nicetyPages, _toConsumableArray(genArray(1, 5)));
    } else if (page > totalPage - 4) {
      nicetyPages.push.apply(nicetyPages, _toConsumableArray(genArray(totalPage - 4, totalPage)));
    } else {
      nicetyPages.push.apply(nicetyPages, _toConsumableArray(genArray(page - 2, page + 2)));
    }

    page <= totalPage - 4 && nicetyPages.push('>>', totalPage);
    page >= 5 && nicetyPages.unshift(1, '<<');
  }

  var nicetyPagination = /*#__PURE__*/React.createElement("div", {
    className: classNames(prefixCls, 'nicety', {
      bordered: bordered,
      disabled: disabled
    }, className),
    style: style
  }, Total, /*#__PURE__*/React.createElement("ul", {
    className: "".concat(prefixCls, "-pages")
  }, /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('pages-item', paginationLangMsg.prevPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handlePrev,
    disabled: page === 1 || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-left"
  }))), _mapInstanceProperty(nicetyPages).call(nicetyPages, function (item, index) {
    var handleChangePage = function handleChangePage() {
      return typeof item === 'string' ? item === '<<' ? jumpPrev() : jumpNext() : changePage(item);
    };

    var pageText = typeof item === 'string' ? '...' : item;
    var jumperIconType = item === '<<' ? 'double-arrow-left' : 'double-arrow-right';
    var title = typeof item === 'string' ? paginationLangMsg[item === '<<' ? 'forward' : 'backward'] : String(item);
    return /*#__PURE__*/React.createElement("li", _extends({
      key: index
    }, itemAttr('pages-item', title, item === page)), /*#__PURE__*/React.createElement("button", {
      onClick: handleChangePage,
      disabled: disabled
    }, pageText, typeof item === 'string' && /*#__PURE__*/React.createElement(Icon, {
      type: jumperIconType,
      className: "".concat(prefixCls, "-pages-jumper-icon")
    })));
  }), /*#__PURE__*/React.createElement("li", _extends({}, itemAttr('pages-item', paginationLangMsg.nextPage)), /*#__PURE__*/React.createElement("button", {
    onClick: handleNext,
    disabled: page === totalPage || disabled
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })))), showJumper && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-jumper")
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    disabled: disabled,
    onKeyUp: handleKeyUp,
    onBlur: handleConfirmCurrentPage,
    onChange: handleChangeCurrentPage,
    className: "".concat(prefixCls, "-jumper-input"),
    value: inputPage === undefined ? '' : inputPage
  }), /*#__PURE__*/React.createElement("button", {
    className: "".concat(prefixCls, "-jumper-button"),
    disabled: disabled,
    onClick: handleConfirmCurrentPage
  }, "GO")), showSizeSelector && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-options")
  }, locale.getLangMsg('Pagination', 'perPage', {
    size: /*#__PURE__*/React.createElement(Dropdown, _extends({
      selectable: true,
      trigger: "click",
      selectedKey: size,
      menu: sizeOptions,
      disabled: disabled,
      popperStyle: {
        minWidth: 64
      },
      onItemClick: handleChangeSize,
      getPopupContainer: function getPopupContainer(triggerNode) {
        return triggerNode === null || triggerNode === void 0 ? void 0 : triggerNode.parentElement;
      }
    }, dropdownProps, {
      onVisibleChange: dropdownVisibleChange
    }), /*#__PURE__*/React.createElement("button", {
      className: "".concat(prefixCls, "-options-size")
    }, size, /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-down",
      className: classNames("".concat(prefixCls, "-dropdown-icon"), _defineProperty({}, "".concat(prefixCls, "-dropdown-icon-open"), isOpen))
    })))
  })));
  var mapPagination = {
    basic: normalPagination,
    bill: normalPagination,
    simple: simplePagination,
    less: lessPagination,
    nicety: nicetyPagination
  };
  return hideOnSinglePage && totalPage === 1 ? null : mapPagination[pageType] || mapPagination.basic;
};

Pagination.displayName = 'Pagination';
export default Pagination;